// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'
/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
import "./assets/js/rem";

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)



/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  // if(to.meta.title){
  //   document.title = to.meta.title
  // }
  next();
});
Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {
    Vue.prototype.$translate = (name, text) => {
      return this.$store.state.text[this.$store.state.lang][name][text] || ''
    }
  },
})


// function setRemUnit () {
//   let docEl = document.documentElement;
//   let viewportWidth = docEl.clientWidth;
//   let rem = viewportWidth / 1920 * 100;
//   docEl.style.fontSize = rem + 'px';
// }
// window.addEventListener('resize', setRemUnit);
// window.addEventListener('DOMContentLoaded', setRemUnit);


// WEBPACK FOOTER //
// ./src/main.js